import { ReactNode, useRef, useState } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';
import { cn } from '@/lib/utils.ts';

type Props = {
  children: ReactNode;
  tooltip?: ReactNode;
  className?: string;
};

const TruncatedCell = ({ children, tooltip, className }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpenChange = (next: boolean) => {
    if (!next) {
      setOpen(false);
      return;
    }
    const el = ref.current;
    if (el && el.scrollWidth > el.clientWidth + 1) {
      setOpen(true);
    }
  };

  return (
    <Tooltip open={open} onOpenChange={handleOpenChange}>
      <TooltipTrigger asChild>
        <div ref={ref} className={cn('truncate', className)}>
          {children}
        </div>
      </TooltipTrigger>
      <TooltipContent>{tooltip ?? children}</TooltipContent>
    </Tooltip>
  );
};

export default TruncatedCell;
